import React from "react";
import "./slogan.css";

function Slogan() {
  return <div className="sloganContainer">
    <p><b>MARS</b> IS GREAT</p>
    <p>BUT</p>
    <p><b>EARTH</b> IS PRESENT</p>
  </div>;
}

export default Slogan;
